module.exports = __webpack_public_path__ + "static/media/up_arrow.d83b481b.svg";